export default __webpack_public_path__ + "static/media/clientjump.f2e12db6.png";